export type MenuSection = {
    key: string;
    title: string;
    paths: string[];
};

export const MENU_SECTIONS: MenuSection[] = [
    {
        key: 'operacao',
        title: 'Operação',
        paths: [
            '/', '/dashboard', '/clientes', '/recorrencias', '/fila-espera',
            '/ofertas-horario', '/lembretes', '/whatsapp', '/vendas',
            '/assinaturas', '/planos', '/minha-agenda',
        ],
    },
    {
        key: 'gestao',
        title: 'Gestão',
        paths: [
            '/servicos', '/estoque', '/financeiro', '/grupos-clientes',
            '/atendentes', '/meu-plano',
            '/configuracoes/pagamentos', '/meus-estabelecimentos',
        ],
    },
    {
        key: 'sistema',
        title: 'Sistema',
        paths: ['/estabelecimentos', '/cobrancas-saas', '/usuario-sistema'],
    },
];

export const getMenuSectionKey = (path: string) =>
    MENU_SECTIONS.find((section) => section.paths.includes(path))?.key || 'outros';
